import React from 'react';

import { highlightText } from 'utils/common';
import logoIcon from 'assets/icons/Logo-small.svg';
import { AdminRole, ClinicUserRole } from 'context/userContext';
import { getAdminViewName, getLocationName } from './utils';
import ClinicOption from './Option';

const CurrentView = ({
  currentClinicUserRole,
  adminRole,
  searchingValue,
}: {
  currentClinicUserRole: ClinicUserRole | null;
  adminRole: AdminRole | null;
  searchingValue: string;
}) => {
  const adminViewName = getAdminViewName(adminRole);

  if (currentClinicUserRole) {
    const clinicName = currentClinicUserRole.clinic.name;

    const parts = highlightText(clinicName, searchingValue);

    return (
      <div className="w-full pb-0.8">
        <div className="text-[1rem] font-bold text-mid-grey mb-0.8">
          CURRENT VIEW
        </div>

        <ClinicOption
          option={{
            avatar: currentClinicUserRole.clinic.avatar,
            name: currentClinicUserRole.clinic.name,
            description: getLocationName(currentClinicUserRole.clinic.location),
          }}
          isActive
          highlightedParts={parts}
        />
      </div>
    );
  } else if (adminViewName) {
    const parts = highlightText(adminViewName, searchingValue);
    return (
      <div className="w-full pb-0.8">
        <div className="text-[1rem] font-bold text-mid-grey mb-0.8">
          CURRENT VIEW
        </div>

        <ClinicOption
          option={{
            avatar: logoIcon,
            name: adminViewName,
          }}
          isActive
          isGlobalAdmin
          highlightedParts={parts}
        />
      </div>
    );
  }

  return null;
};

export default CurrentView;
